module.exports = __webpack_public_path__ + "img/top0.4ec5c6e.png";